import checkMatchingChats from './checkMatchingChats'

export default checkMatchingChats
